import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import getChartData from "utils/getChartData";
import Chart from "Components/Common/Chart";

const CategoryWiseNumberOfConsumerBarChart = ({
  categoryType,
  utilityConsumerMonthWise,
}) => {
  const initialOption = {
    chart: {
      type: "bar",
      stacked: true,
    },
    colors: [categoryType.color],
    plotOptions: {
      bar: {
        horizontal: false,
        dataLabels: {
          total: {
            enabled: true,
            offsetX: 0,
            style: {
              fontSize: "13px",
              fontWeight: 900,
            },
          },
        },
      },
    },
    stroke: {
      width: 1,
      colors: ["#fff"],
    },
    xaxis: {
      categories: [],
      labels: {
        formatter: function (val) {
          return val;
        },
        style: {
          fontWeight: 700,
          fontSize: "14px",
          colors: "#000",
        },
      },
    },
    yaxis: {
      title: {
        text: undefined,
      },
      labels: {
        style: {
          fontWeight: 700,
          fontSize: "14px",
          colors: "#000",
        },
      },
    },
    fill: {
      opacity: 1,
    },
    legend: {
      position: "bottom",
      horizontalAlign: "left",
      offsetX: 40,
    },
  };
  const [data, setData] = useState({});
  const [options, setOptions] = useState(initialOption);
  const series = useMemo(
    () => [
      {
        name: categoryType.title,
        data: data?.[categoryType.title] || [],
      },
    ],
    [data]
  );

  useEffect(() => {
    if (utilityConsumerMonthWise) {
      const { barChartData, barChartLabels } = getChartData(
        utilityConsumerMonthWise,
        "utilityConsumerCategoryCount",
        "category",
        "count",
        "month"
      );

      setData(barChartData);
      setOptions((prev) => ({
        ...prev,
        xaxis: { ...prev.xaxis, categories: barChartLabels },
        colors: [categoryType.color],
      }));
    }
  }, [utilityConsumerMonthWise, categoryType?.title]);

  return (
    <Chart
      title={categoryType.title}
      options={options}
      series={series}
      height={480}
      type="bar"
    />
  );
};

CategoryWiseNumberOfConsumerBarChart.propTypes = {
  categoryType: PropTypes.object,
  utilityConsumerMonthWise: PropTypes.array,
};

export default CategoryWiseNumberOfConsumerBarChart;
